import axios from "axios";

import {
  reducerClientContracts,
  reducerClientSettings,
  reducerClientRegions,
  reducerClientFilters,
} from "../../reducer/accessRights/reducers/customersList";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

import { ISettingCustomer } from "../../../types/interfaces";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetClientSettings =
  (id: string | undefined) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/auth/customer/${id}/settings`
      );

      dispatch(reducerClientContracts(response.data.settings.contracts));
      dispatch(reducerClientRegions(response.data.settings.regions));
      dispatch(reducerClientSettings(response.data.settings));
      dispatch(reducerClientFilters(response.data));
      return true;
    } catch {
      console.log('err');
      return false;
    }
  };

export const actionUpdateClientContracts =
  (id: string | undefined, data: { id: number }[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/auth/customer/${id}/contracts`,
        data
      );

      dispatch(reducerClientContracts(response.data));
    } catch {
      console.log('err');
    }
  };

export const actionUpdateClientRegions =
  (id: string | undefined, data: {
    areas: { area: { id: number } }[];
    region: { id: number };
  }) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/auth/customer/${id}/regions`,
        data
      );
  
      dispatch(reducerClientRegions(response.data)); 
    } catch {
      console.log('err');
    }
  };

export const actionUpdateClientSettings =
  (id: string | undefined, data: ISettingCustomer) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.patch(
        `${BASE_URL}/json/auth/customer/${id}/settings`,
        data
      );
      dispatch(reducerClientSettings(response.data.settings));
      dispatch(reducerClientFilters(response.data));
    } catch {
      console.log('err');
    }
  };
